module.exports = __webpack_public_path__ + "img/medtronic_invos.56ead778.png";